"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Account = Account;

require("core-js/modules/es6.object.freeze");

var _utils = require("../../helpers/utils");
/**
 * Template: Customer Account
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Account
 * template.
 *
 * @namespace Account
 */


function Account() {
  /**
   * Initialize address form events.
   */
  function init() {
    freeReadsCookieCheck();
    var logoutLink = document.querySelector('[href="/account/logout"]');
    (0, _utils.on)('click', logoutLink, function () {
      console.log('Logging out');

      if (window.localStorage.getItem('mb-customer-access-token') !== null) {
        window.localStorage.removeItem(window.localStorage.getItem('mb-customer-access-token'));
        window.localStorage.removeItem('mb-customer-access-token');
      }
    });
  }
  /**
   * If the user navigates from Free Reads -> Login/Register, a storage item
   * is set. Likewise when they attempt a login/register attempt.
   * If they redirect to the acccount page and both cookie are set, send
   * them back to the free reads page.
   */


  function freeReadsCookieCheck() {
    window.console.log('in freeReadsCookieCheck');

    if (window.sessionStorage.getItem('mb_submit_attempt') === null) {
      return;
    }

    if (window.sessionStorage.getItem('mb_free_reads') === null) {
      return;
    }

    var redirectLocation = window.sessionStorage.getItem('mb_free_reads');
    window.sessionStorage.removeItem('mb_free_reads');
    window.sessionStorage.removeItem('mb_submit_attempt');
    var redirectTemplate = "<div class=\"free-reads-redirect\">\n      <span>Redirecting you to your free read...</span>\n      <a href=\"".concat(redirectLocation, "\">Click here if your browser doesn't automatically redirect you</a>\n    </div>");
    document.querySelector('body').insertAdjacentHTML('afterbegin', redirectTemplate);
    window.location = redirectLocation;
  }

  return Object.freeze({
    init: init
  });
}

Account().init();